import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
  top: ${(props) => props.hasAppHeader ? '60px' : 0};
  right: 0;
  bottom: 0;
  left: 0;
  color: ${(props) => props.theme['color.text.body']};
`;
